import { render, staticRenderFns } from "./TolAlert.vue?vue&type=template&id=4d6c6332&scoped=true&"
import script from "./TolAlert.vue?vue&type=script&lang=js&"
export * from "./TolAlert.vue?vue&type=script&lang=js&"
import style0 from "./TolAlert.vue?vue&type=style&index=0&id=4d6c6332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c6332",
  null
  
)

export default component.exports